// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./icons/status/no.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./icons/status/partial.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./icons/status/yes-circle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Compat (mobile *and* desktop). */

table {
  display: grid;
  grid-auto-flow: row dense;

  thead {
    tr {
      display: contents;

      th,
      td {
        display: grid;
        grid-template-columns: subgrid;
      }
    }
  }

  tbody {
    display: contents;

    tr {
      display: contents;

      th,
      td {
        display: contents;

        button {
          display: grid;
          grid-template-columns: subgrid;
        }

        .timeline {
          grid-column: 1 / -1;
        }
      }
    }
  }
}

.bc-on-github {
  font-size: var(--compat-type-smaller-font-size);
}

.bc-table {
  width: 100%;

  margin: 0;

  border-spacing: 0;
  border-collapse: separate;

  border: 1px solid var(--compat-border-primary);
  border-radius: var(--compat-elem-radius);

  td,
  th {
    padding: 0;
    padding: 0.4rem;

    font-size: var(--compat-type-smaller-font-size);
    font-weight: 500;

    border: 1px solid var(--compat-border-secondary);
    border-width: 0 0 1px 1px;

    code {
      font-size: var(--compat-type-smaller-font-size);
    }
  }

  th {
    padding: 0.4rem;
    vertical-align: bottom;
    background: var(--compat-background-primary);
  }

  thead {
    line-height: 1;
    white-space: nowrap;
  }

  /*
     * these props allow us to add border-radius to the table.
     * border-collapse: separate gets in the way of this
     * being easy.
     */
  tbody {
    tr {
      height: 3rem;

      @media (width >= /* \$screen-sm */ 426px) {
        &:last-child {
          th,
          td {
            border-bottom-width: 0;
          }
        }
      }

      th {
        vertical-align: middle;
        border-left-width: 0;
      }
    }

    .bc-support {
      vertical-align: top;

      button {
        width: 100%;
        cursor: pointer;
      }

      &.bc-supports-no > button > span {
        color: var(--compat-text-primary-red);
      }

      &.bc-supports-partial > button > span {
        color: var(--compat-text-primary-yellow);
      }

      &.bc-supports-preview > button > span {
        color: var(--compat-text-primary-blue);
      }

      &.bc-supports-yes > button > span {
        color: var(--compat-text-primary-green);
      }
    }
  }

  .bc-supports {
    margin-bottom: 1rem;

    .icon-wrap {
      background: var(--compat-background-primary);
    }
  }

  .bc-supports.bc-supports-removed-partial {
    .bcd-cell-text-copy {
      color: var(--compat-text-primary-yellow);
    }
  }

  .icon-wrap {
    .bc-support-level {
      position: absolute !important;

      width: 1px !important;
      height: 1px !important;

      padding: 0 !important;
      margin: -1px !important;

      overflow: hidden !important;

      white-space: nowrap !important;

      /* visually-hidden */
      border: 0 !important;

      clip: rect(1px, 1px, 1px, 1px) !important;
      clip-path: inset(50%) !important;
    }
  }

  .bc-support {
    > button > .icon-wrap {
      display: block;
    }

    .icon.icon-removed-partial {
      background-color: var(--compat-icon-critical);

      /* override icon */
      mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    }

    .timeline .icon.icon-removed-partial {
      background-color: var(--compat-icon-primary);
      mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    }
  }

  .bc-support.bc-supports-removed-partial {
    .bcd-cell-text-copy {
      color: var(--compat-text-primary-red);
    }
  }

  .bc-feature {
    display: flex;

    align-items: center;

    width: 100%;

    text-align: left;

    border: none;

    > * {
      flex-basis: max-content;
      border: none !important;
    }
  }

  .bc-feature-depth-2 {
    border-left: 7px solid var(--compat-border-primary);
  }

  .bc-feature-depth-3 {
    border-left: 15px solid var(--compat-border-primary);
  }

  .timeline {
    display: none;
  }

  .bc-has-history:focus-within .timeline {
    display: initial;
  }
}

.bc-head-txt-label {
  line-height: 1;

  white-space: nowrap;

  writing-mode: vertical-rl;

  transform: rotate(180deg);
  text-orientation: sideways;
}

.bc-support {
  vertical-align: middle;
  text-align: center;
}

.bc-level-no {
  background-color: var(--compat-icon-critical);
}

.bc-level-preview {
  background-color: var(--compat-icon-information);
}

.bc-legend-items-container {
  display: flex;

  flex-wrap: wrap;

  gap: 1.5rem;

  margin-bottom: 2rem;

  font-size: var(--compat-type-smaller-font-size);
}

.bc-legend-tip {
  margin-top: 0;
  margin-bottom: 1rem;

  font-size: var(--compat-type-smaller-font-size);
  font-variation-settings: "slnt" -10;
  font-style: italic;
}

.bc-legend-item {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.bc-legend-item-dt {
  display: flex;

  .icon {
    background-color: var(--compat-icon-primary);
  }
}

/* Row with desktop / mobile icons. */
.bc-platforms {
  th {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  td {
    border: none;
  }
}

/* Row with browser names. */
.bc-browsers {
  th {
    display: flex;

    flex-direction: column;

    gap: 0.25rem;
    align-items: center;
    justify-content: end;

    vertical-align: bottom;
  }

  td {
    border-width: 0 0 1px;
  }
}

.bc-notes-list {
  position: relative;

  width: 100%;

  margin: 0.5rem 0;

  text-align: left;

  &::before {
    position: absolute;
    left: 7px;
    z-index: -1;

    width: 2px;
    height: calc(100% - 0.25rem);

    margin-top: 0.25rem;

    content: "";

    background: var(--compat-border-primary);
  }

  /* complicated selector to cover the last bit of the grey line above. */
  .bc-notes-wrapper:last-child dd:last-child {
    position: relative;

    &::before {
      position: absolute;
      bottom: 0;
      left: 7px;
      z-index: -1;

      width: 2px;
      height: calc(100% - 6px);

      content: "";

      background: var(--compat-background-primary);
    }
  }

  .bc-level-yes.icon.icon-yes {
    /* override icon */
    background-color: var(--compat-icon-success);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }

  .bc-supports-dd {
    .icon {
      background: var(--compat-border-primary);
      border: 3px solid var(--compat-background-primary);
      border-radius: 50%;

      mask-image: none;
    }
  }

  .bc-version-label {
    display: inline;
  }

  abbr {
    margin-right: 4px;
    text-decoration: none;
  }

  dd {
    padding-left: 1.5rem;
    margin-bottom: 1rem;
    text-indent: -1.5rem;

    &:last-child {
      margin-bottom: 2rem;
    }
  }
}

.bc-notes-wrapper {
  margin-bottom: 1rem;
  color: var(--compat-text-primary);

  &:last-child {
    margin-bottom: 0;
  }
}

dl.bc-notes-list {
  dt.bc-supports {
    margin-top: 1rem;

    &:first-child {
      margin-top: 0;
    }
  }

  dd.bc-supports-dd {
    margin-bottom: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.only-icon span {
  position: absolute !important;

  width: 1px !important;
  height: 1px !important;

  padding: 0 !important;
  margin: -1px !important;

  overflow: hidden !important;

  white-space: nowrap !important;

  /* visually-hidden */
  border: 0 !important;

  clip: rect(1px, 1px, 1px, 1px) !important;
  clip-path: inset(50%) !important;
}

.bc-table-row-header {
  width: 100%;
  padding: 0.25em;
  text-align: left;

  code {
    overflow: hidden;
  }

  .bc-icons {
    display: inline-flex;

    gap: 0.5ch;

    margin-left: 0.5ch;

    vertical-align: text-top;

    .icon {
      background-color: var(--compat-icon-secondary);

      &:hover {
        background-color: var(--compat-icon-primary);
      }
    }
  }
}

.bc-github-link {
  font: var(--compat-type-smaller-font-size);
}

.main-page-content {
  .bc-legend {
    dd,
    dt {
      margin-top: 0;
      margin-bottom: 0;
      margin-left: 0;
    }
  }

  .bc-supports-dd {
    margin: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./components/compat/index-common.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,aAAa;EACb,yBAAyB;;EAEzB;IACE;MACE,iBAAiB;;MAEjB;;QAEE,aAAa;QACb,8BAA8B;MAChC;IACF;EACF;;EAEA;IACE,iBAAiB;;IAEjB;MACE,iBAAiB;;MAEjB;;QAEE,iBAAiB;;QAEjB;UACE,aAAa;UACb,8BAA8B;QAChC;;QAEA;UACE,mBAAmB;QACrB;MACF;IACF;EACF;AACF;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,WAAW;;EAEX,SAAS;;EAET,iBAAiB;EACjB,yBAAyB;;EAEzB,8CAA8C;EAC9C,wCAAwC;;EAExC;;IAEE,UAAU;IACV,eAAe;;IAEf,+CAA+C;IAC/C,gBAAgB;;IAEhB,gDAAgD;IAChD,yBAAyB;;IAEzB;MACE,+CAA+C;IACjD;EACF;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,4CAA4C;EAC9C;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;;;;MAII;EACJ;IACE;MACE,YAAY;;MAEZ;QACE;UACE;;YAEE,sBAAsB;UACxB;QACF;MACF;;MAEA;QACE,sBAAsB;QACtB,oBAAoB;MACtB;IACF;;IAEA;MACE,mBAAmB;;MAEnB;QACE,WAAW;QACX,eAAe;MACjB;;MAEA;QACE,qCAAqC;MACvC;;MAEA;QACE,wCAAwC;MAC1C;;MAEA;QACE,sCAAsC;MACxC;;MAEA;QACE,uCAAuC;MACzC;IACF;EACF;;EAEA;IACE,mBAAmB;;IAEnB;MACE,4CAA4C;IAC9C;EACF;;EAEA;IACE;MACE,wCAAwC;IAC1C;EACF;;EAEA;IACE;MACE,6BAA6B;;MAE7B,qBAAqB;MACrB,sBAAsB;;MAEtB,qBAAqB;MACrB,uBAAuB;;MAEvB,2BAA2B;;MAE3B,8BAA8B;;MAE9B,oBAAoB;MACpB,oBAAoB;;MAEpB,yCAAyC;MACzC,gCAAgC;IAClC;EACF;;EAEA;IACE;MACE,cAAc;IAChB;;IAEA;MACE,6CAA6C;;MAE7C,kBAAkB;MAClB,mDAAwC;IAC1C;;IAEA;MACE,4CAA4C;MAC5C,mDAA6C;IAC/C;EACF;;EAEA;IACE;MACE,qCAAqC;IACvC;EACF;;EAEA;IACE,aAAa;;IAEb,mBAAmB;;IAEnB,WAAW;;IAEX,gBAAgB;;IAEhB,YAAY;;IAEZ;MACE,uBAAuB;MACvB,uBAAuB;IACzB;EACF;;EAEA;IACE,mDAAmD;EACrD;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;;EAEd,mBAAmB;;EAEnB,yBAAyB;;EAEzB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;;EAEb,eAAe;;EAEf,WAAW;;EAEX,mBAAmB;;EAEnB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,+CAA+C;EAC/C,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;;EAEb;IACE,4CAA4C;EAC9C;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,aAAa;;IAEb,sBAAsB;;IAEtB,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;;IAEpB,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;;EAElB,WAAW;;EAEX,gBAAgB;;EAEhB,gBAAgB;;EAEhB;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;;IAEX,UAAU;IACV,4BAA4B;;IAE5B,mBAAmB;;IAEnB,WAAW;;IAEX,wCAAwC;EAC1C;;EAEA,uEAAuE;EACvE;IACE,kBAAkB;;IAElB;MACE,kBAAkB;MAClB,SAAS;MACT,SAAS;MACT,WAAW;;MAEX,UAAU;MACV,wBAAwB;;MAExB,WAAW;;MAEX,4CAA4C;IAC9C;EACF;;EAEA;IACE,kBAAkB;IAClB,4CAA4C;IAC5C,mDAAgD;EAClD;;EAEA;IACE;MACE,wCAAwC;MACxC,kDAAkD;MAClD,kBAAkB;;MAElB,gBAAgB;IAClB;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;;IAEpB;MACE,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;;EAEjC;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;;IAEhB;MACE,aAAa;IACf;EACF;;EAEA;IACE,mBAAmB;;IAEnB;MACE,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,6BAA6B;;EAE7B,qBAAqB;EACrB,sBAAsB;;EAEtB,qBAAqB;EACrB,uBAAuB;;EAEvB,2BAA2B;;EAE3B,8BAA8B;;EAE9B,oBAAoB;EACpB,oBAAoB;;EAEpB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;;EAEhB;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;;IAEpB,UAAU;;IAEV,kBAAkB;;IAElB,wBAAwB;;IAExB;MACE,8CAA8C;;MAE9C;QACE,4CAA4C;MAC9C;IACF;EACF;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE;;MAEE,aAAa;MACb,gBAAgB;MAChB,cAAc;IAChB;EACF;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":["/* Compat (mobile *and* desktop). */\n\ntable {\n  display: grid;\n  grid-auto-flow: row dense;\n\n  thead {\n    tr {\n      display: contents;\n\n      th,\n      td {\n        display: grid;\n        grid-template-columns: subgrid;\n      }\n    }\n  }\n\n  tbody {\n    display: contents;\n\n    tr {\n      display: contents;\n\n      th,\n      td {\n        display: contents;\n\n        button {\n          display: grid;\n          grid-template-columns: subgrid;\n        }\n\n        .timeline {\n          grid-column: 1 / -1;\n        }\n      }\n    }\n  }\n}\n\n.bc-on-github {\n  font-size: var(--compat-type-smaller-font-size);\n}\n\n.bc-table {\n  width: 100%;\n\n  margin: 0;\n\n  border-spacing: 0;\n  border-collapse: separate;\n\n  border: 1px solid var(--compat-border-primary);\n  border-radius: var(--compat-elem-radius);\n\n  td,\n  th {\n    padding: 0;\n    padding: 0.4rem;\n\n    font-size: var(--compat-type-smaller-font-size);\n    font-weight: 500;\n\n    border: 1px solid var(--compat-border-secondary);\n    border-width: 0 0 1px 1px;\n\n    code {\n      font-size: var(--compat-type-smaller-font-size);\n    }\n  }\n\n  th {\n    padding: 0.4rem;\n    vertical-align: bottom;\n    background: var(--compat-background-primary);\n  }\n\n  thead {\n    line-height: 1;\n    white-space: nowrap;\n  }\n\n  /*\n     * these props allow us to add border-radius to the table.\n     * border-collapse: separate gets in the way of this\n     * being easy.\n     */\n  tbody {\n    tr {\n      height: 3rem;\n\n      @media (width >= /* $screen-sm */ 426px) {\n        &:last-child {\n          th,\n          td {\n            border-bottom-width: 0;\n          }\n        }\n      }\n\n      th {\n        vertical-align: middle;\n        border-left-width: 0;\n      }\n    }\n\n    .bc-support {\n      vertical-align: top;\n\n      button {\n        width: 100%;\n        cursor: pointer;\n      }\n\n      &.bc-supports-no > button > span {\n        color: var(--compat-text-primary-red);\n      }\n\n      &.bc-supports-partial > button > span {\n        color: var(--compat-text-primary-yellow);\n      }\n\n      &.bc-supports-preview > button > span {\n        color: var(--compat-text-primary-blue);\n      }\n\n      &.bc-supports-yes > button > span {\n        color: var(--compat-text-primary-green);\n      }\n    }\n  }\n\n  .bc-supports {\n    margin-bottom: 1rem;\n\n    .icon-wrap {\n      background: var(--compat-background-primary);\n    }\n  }\n\n  .bc-supports.bc-supports-removed-partial {\n    .bcd-cell-text-copy {\n      color: var(--compat-text-primary-yellow);\n    }\n  }\n\n  .icon-wrap {\n    .bc-support-level {\n      position: absolute !important;\n\n      width: 1px !important;\n      height: 1px !important;\n\n      padding: 0 !important;\n      margin: -1px !important;\n\n      overflow: hidden !important;\n\n      white-space: nowrap !important;\n\n      /* visually-hidden */\n      border: 0 !important;\n\n      clip: rect(1px, 1px, 1px, 1px) !important;\n      clip-path: inset(50%) !important;\n    }\n  }\n\n  .bc-support {\n    > button > .icon-wrap {\n      display: block;\n    }\n\n    .icon.icon-removed-partial {\n      background-color: var(--compat-icon-critical);\n\n      /* override icon */\n      mask-image: url(\"./icons/status/no.svg\");\n    }\n\n    .timeline .icon.icon-removed-partial {\n      background-color: var(--compat-icon-primary);\n      mask-image: url(\"./icons/status/partial.svg\");\n    }\n  }\n\n  .bc-support.bc-supports-removed-partial {\n    .bcd-cell-text-copy {\n      color: var(--compat-text-primary-red);\n    }\n  }\n\n  .bc-feature {\n    display: flex;\n\n    align-items: center;\n\n    width: 100%;\n\n    text-align: left;\n\n    border: none;\n\n    > * {\n      flex-basis: max-content;\n      border: none !important;\n    }\n  }\n\n  .bc-feature-depth-2 {\n    border-left: 7px solid var(--compat-border-primary);\n  }\n\n  .bc-feature-depth-3 {\n    border-left: 15px solid var(--compat-border-primary);\n  }\n\n  .timeline {\n    display: none;\n  }\n\n  .bc-has-history:focus-within .timeline {\n    display: initial;\n  }\n}\n\n.bc-head-txt-label {\n  line-height: 1;\n\n  white-space: nowrap;\n\n  writing-mode: vertical-rl;\n\n  transform: rotate(180deg);\n  text-orientation: sideways;\n}\n\n.bc-support {\n  vertical-align: middle;\n  text-align: center;\n}\n\n.bc-level-no {\n  background-color: var(--compat-icon-critical);\n}\n\n.bc-level-preview {\n  background-color: var(--compat-icon-information);\n}\n\n.bc-legend-items-container {\n  display: flex;\n\n  flex-wrap: wrap;\n\n  gap: 1.5rem;\n\n  margin-bottom: 2rem;\n\n  font-size: var(--compat-type-smaller-font-size);\n}\n\n.bc-legend-tip {\n  margin-top: 0;\n  margin-bottom: 1rem;\n\n  font-size: var(--compat-type-smaller-font-size);\n  font-variation-settings: \"slnt\" -10;\n  font-style: italic;\n}\n\n.bc-legend-item {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.bc-legend-item-dt {\n  display: flex;\n\n  .icon {\n    background-color: var(--compat-icon-primary);\n  }\n}\n\n/* Row with desktop / mobile icons. */\n.bc-platforms {\n  th {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  td {\n    border: none;\n  }\n}\n\n/* Row with browser names. */\n.bc-browsers {\n  th {\n    display: flex;\n\n    flex-direction: column;\n\n    gap: 0.25rem;\n    align-items: center;\n    justify-content: end;\n\n    vertical-align: bottom;\n  }\n\n  td {\n    border-width: 0 0 1px;\n  }\n}\n\n.bc-notes-list {\n  position: relative;\n\n  width: 100%;\n\n  margin: 0.5rem 0;\n\n  text-align: left;\n\n  &::before {\n    position: absolute;\n    left: 7px;\n    z-index: -1;\n\n    width: 2px;\n    height: calc(100% - 0.25rem);\n\n    margin-top: 0.25rem;\n\n    content: \"\";\n\n    background: var(--compat-border-primary);\n  }\n\n  /* complicated selector to cover the last bit of the grey line above. */\n  .bc-notes-wrapper:last-child dd:last-child {\n    position: relative;\n\n    &::before {\n      position: absolute;\n      bottom: 0;\n      left: 7px;\n      z-index: -1;\n\n      width: 2px;\n      height: calc(100% - 6px);\n\n      content: \"\";\n\n      background: var(--compat-background-primary);\n    }\n  }\n\n  .bc-level-yes.icon.icon-yes {\n    /* override icon */\n    background-color: var(--compat-icon-success);\n    mask-image: url(\"./icons/status/yes-circle.svg\");\n  }\n\n  .bc-supports-dd {\n    .icon {\n      background: var(--compat-border-primary);\n      border: 3px solid var(--compat-background-primary);\n      border-radius: 50%;\n\n      mask-image: none;\n    }\n  }\n\n  .bc-version-label {\n    display: inline;\n  }\n\n  abbr {\n    margin-right: 4px;\n    text-decoration: none;\n  }\n\n  dd {\n    padding-left: 1.5rem;\n    margin-bottom: 1rem;\n    text-indent: -1.5rem;\n\n    &:last-child {\n      margin-bottom: 2rem;\n    }\n  }\n}\n\n.bc-notes-wrapper {\n  margin-bottom: 1rem;\n  color: var(--compat-text-primary);\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\ndl.bc-notes-list {\n  dt.bc-supports {\n    margin-top: 1rem;\n\n    &:first-child {\n      margin-top: 0;\n    }\n  }\n\n  dd.bc-supports-dd {\n    margin-bottom: 1rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.only-icon span {\n  position: absolute !important;\n\n  width: 1px !important;\n  height: 1px !important;\n\n  padding: 0 !important;\n  margin: -1px !important;\n\n  overflow: hidden !important;\n\n  white-space: nowrap !important;\n\n  /* visually-hidden */\n  border: 0 !important;\n\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  clip-path: inset(50%) !important;\n}\n\n.bc-table-row-header {\n  width: 100%;\n  padding: 0.25em;\n  text-align: left;\n\n  code {\n    overflow: hidden;\n  }\n\n  .bc-icons {\n    display: inline-flex;\n\n    gap: 0.5ch;\n\n    margin-left: 0.5ch;\n\n    vertical-align: text-top;\n\n    .icon {\n      background-color: var(--compat-icon-secondary);\n\n      &:hover {\n        background-color: var(--compat-icon-primary);\n      }\n    }\n  }\n}\n\n.bc-github-link {\n  font: var(--compat-type-smaller-font-size);\n}\n\n.main-page-content {\n  .bc-legend {\n    dd,\n    dt {\n      margin-top: 0;\n      margin-bottom: 0;\n      margin-left: 0;\n    }\n  }\n\n  .bc-supports-dd {\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
